import React from 'react';
import { FiCodepen, FiFigma, FiLayers, FiCloud } from "react-icons/fi";
import {Link} from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const ServiceList = [
    {
        icon: <FiFigma />,
        title: 'UI Design',
        description: 'We design your digital solutions by following UI best practices, maintaining the highest standards.'
    },
    {
        icon: <FiCodepen />,
        title: 'Architecture',
        description: 'Structuring and modelling data blocks according to modular principles is one of our corre abilities'
    },
    {
        icon: <FiLayers />,
        title: 'Web Development',
        description: 'Our team is experienced in Web Technologies and will ensure the highest standards are met.'
    },
    {
        icon: <FiCloud />,
        title: 'Cloud Hosting',
        description: 'All of our systems and solutions are hosted in the Cloud. Choose among a variety of Cloud providers.'
    },
]

const ServiceOne = ({textAlign, serviceStyle}) => {
    return (
        <div className="row row--15 service-wrapper">
              {ServiceList.map( (val , i) => (
                <div className="col-lg-3 col-md-6 col-sm-6 col-12" key={i}>
                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <div className={`service ${serviceStyle} ${textAlign}`}>
                            <div className="icon">
                                {val.icon}
                            </div>
                            <div className="content">
                                <h4 className="title w-600"><Link to="#service" dangerouslySetInnerHTML={{__html: val.title}}></Link></h4>
                                <p className="description b1 color-gray mb--0" dangerouslySetInnerHTML={{__html: val.description}}></p>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
export default ServiceOne;